import styled from 'styled-components';
import { Row } from '../../grid';
import { Gray, White } from '../../../colors';
import { flexCenterY } from '../../../utils/mixins';
import { SCREEN_SIZE } from '../../grid/constants/sizes';
export const OriginationFlowContent = styled.div `
    width: 100%;
    height: 100%;
    min-height: calc(100vh - 70px);
    background-color: ${White.normal};

    @media (max-width: ${SCREEN_SIZE.MOBILE.max}) {
        margin: 0 -15px;
        padding: 0 15px;
    }
`;
export const PaneltHeader = styled.div `
    height: 70px;
    ${flexCenterY}
`;
export const ContentHeader = styled.div `
    height: 70px;
    ${flexCenterY}
    background-color: ${White.normal};
    border-bottom: solid 1px ${Gray.normal};


    @media (max-width: ${SCREEN_SIZE.MOBILE.max}) {
        position: relative;
        margin: 0 -15px;
        padding: 0 15px;
        box-shadow: 0 1px 6px ${Gray.normal};
    }
`;
// @ts-ignore
export const RowHeader = styled(Row) `
    background-color: ${White.normal};
    height: 90px;
    z-index: 1000;

    @media (max-width: ${SCREEN_SIZE.MOBILE.max}) {
        height: 64px;
    }
`;
export const RowContent = styled(Row) `
    align-content: center;
    height: 100%;

    @media (max-width: ${SCREEN_SIZE.TABLET.max}) {
        position: relative;
        padding: 15px;
        height: auto;
    }
`;
export const RowChildren = styled(Row) `
    overflow: auto;
    z-index: 100;
`;
export const BackgroundHeader = styled('div') `
    width: 100%;
    height: 90px;
    background-color: ${White.normal};

    @media (max-width: ${SCREEN_SIZE.MOBILE.max}) {
        height: 64px;
    }
`;
//# sourceMappingURL=PaylinkLayout.Styled.js.map